interface IconProps {
  size?: number;
}

const CLOCK_PATH_PRIMARY =
  'M61.7,45.07c-1.22,0-2.21.99-2.21,2.21v11.07c0,.59.23,1.15.65,1.56l6.64,6.64c.88.85,2.28.82,3.13-.05.83-.86.83-2.22,0-3.07l-5.99-5.99v-10.15c0-1.22-.99-2.21-2.21-2.21ZM87.84,54.22c-2.29-14.49-15.89-24.38-30.37-22.09-5.43.86-10.47,3.38-14.41,7.22v-5.34c0-1.22-.99-2.21-2.21-2.21s-2.21.99-2.21,2.21v8.85c0,2.44,1.98,4.43,4.43,4.43h8.85c1.22,0,2.21-.99,2.21-2.21s-.99-2.21-2.21-2.21h-6.09c8.57-8.7,22.57-8.8,31.26-.24,8.7,8.57,8.8,22.57.24,31.26-8.57,8.7-22.57,8.8-31.26.24-3.75-3.69-6.05-8.59-6.51-13.83-.12-1.12-1.07-1.96-2.2-1.94-1.23,0-2.23,1-2.22,2.23,0,.07,0,.13,0,.2,1.45,14.6,14.45,25.25,29.05,23.8,14.6-1.45,25.25-14.45,23.8-29.05-.04-.44-.1-.88-.17-1.33h0Z';

const CLOCK_PATH_SUB =
  'M58.7,45.07c-1.22,0-2.21.99-2.21,2.21v11.07c0,.59.23,1.15.65,1.56l6.64,6.64c.88.85,2.28.82,3.13-.05.83-.86.83-2.22,0-3.07l-5.99-5.99v-10.15c0-1.22-.99-2.21-2.21-2.21ZM84.84,54.22c-2.29-14.49-15.89-24.38-30.37-22.09-5.43.86-10.47,3.38-14.41,7.22v-5.34c0-1.22-.99-2.21-2.21-2.21s-2.21.99-2.21,2.21v8.85c0,2.44,1.98,4.43,4.43,4.43h8.85c1.22,0,2.21-.99,2.21-2.21s-.99-2.21-2.21-2.21h-6.09c8.57-8.7,22.57-8.8,31.26-.24,8.7,8.57,8.8,22.57.24,31.26-8.57,8.7-22.57,8.8-31.26.24-3.75-3.69-6.05-8.59-6.51-13.83-.12-1.12-1.07-1.96-2.2-1.94-1.23,0-2.23,1-2.22,2.23,0,.07,0,.13,0,.2,1.45,14.6,14.45,25.25,29.05,23.8,14.6-1.45,25.25-14.45,23.8-29.05-.04-.44-.1-.88-.17-1.33h0Z';

const GIFT_PATH =
  'M82.19,42.86h-10.08c2.45,0,4.49-2,4.49-4.45s-1.98-4.43-4.43-4.43c0-2.75-2.5-4.92-5.36-4.33-2.08.43-3.52,2.36-3.52,4.48v.89c-.67-.6-1.55-.98-2.52-.98h-5.04c-.97,0-1.85.38-2.52.98v-.89c0-2.12-1.44-4.06-3.52-4.48-2.86-.59-5.37,1.58-5.36,4.33-2.45,0-4.43,1.98-4.43,4.43,0,2.45,2.04,4.45,4.49,4.45h-10.08c-2.78,0-5.04,2.26-5.04,5.04v1.26c0,2.78,2.26,5.04,5.04,5.04h15.12v2.52h-16.38v25.4c0,2.67,2.17,4.84,4.84,4.84h11.54c1.39,0,2.52-1.13,2.52-2.52v-40.32h12.6v40.32c0,1.39,1.13,2.52,2.52,2.52h11.54c2.67,0,4.84-2.17,4.84-4.84v-25.4h-16.38v-2.52h15.12c2.78,0,5.04-2.26,5.04-5.04v-1.26c0-2.78-2.26-5.04-5.04-5.04ZM54.48,41.6v-3.78c0-.69.56-1.26,1.26-1.26h5.04c.7,0,1.26.57,1.26,1.26v3.78h-7.56Z';

function TierIcon({
  size = 28,
  circleFill,
  circleStroke,
  innerFill,
  innerPath,
}: IconProps & { circleFill: string; circleStroke: string; innerFill: string; innerPath: string }) {
  return (
    <svg
      viewBox="0 0 116.51 116.51"
      width={size}
      height={size}
      style={{ display: 'block', flexShrink: 0 }}
    >
      <circle
        cx="58.26"
        cy="58.26"
        r="55.76"
        fill={circleFill}
        stroke={circleStroke}
        strokeMiterlimit={10}
        strokeWidth={5}
      />
      <path fill={innerFill} d={innerPath} />
    </svg>
  );
}

export function PrimaryClockIcon({ size }: IconProps) {
  return (
    <TierIcon
      size={size}
      circleFill="#190d42"
      circleStroke="#35206b"
      innerFill="#964fff"
      innerPath={CLOCK_PATH_PRIMARY}
    />
  );
}

export function PrimaryGiftIcon({ size }: IconProps) {
  return (
    <TierIcon
      size={size}
      circleFill="#190d42"
      circleStroke="#35206b"
      innerFill="#964fff"
      innerPath={GIFT_PATH}
    />
  );
}

export function SubClockIcon({ size }: IconProps) {
  return (
    <TierIcon
      size={size}
      circleFill="#190d42"
      circleStroke="#4a3d6b"
      innerFill="#8d8aa8"
      innerPath={CLOCK_PATH_SUB}
    />
  );
}

export function SubGiftIcon({ size }: IconProps) {
  return (
    <TierIcon
      size={size}
      circleFill="#190d42"
      circleStroke="#4a3d6b"
      innerFill="#8d8aa8"
      innerPath={GIFT_PATH}
    />
  );
}
